export default __webpack_public_path__ + "static/media/warningCheckEmpty.9cd31f4d.svg";